module.exports = __webpack_public_path__ + "img/dashicons_trash.0cd257b3.svg";